import { CHANGE_STEP, SETUP_STATES as setupStates } from '../actions/types';

const initialState = { currentStep: 'signup', progress: -1 };

function signUp(state = initialState, action) {
    switch (action.type) {
        case CHANGE_STEP: {
            const { payload } = action;
            const { currentStep } = state;
            const currentPosition = setupStates.indexOf(currentStep);
            const nextPosition = setupStates.indexOf(payload);
            //validate step position
            if (nextPosition > currentPosition)
                return { ...state, currentStep: payload, progress: nextPosition };
            return state;
        }
        default:
            return state;
    }
}

export default signUp;